import React from 'react';
import { Table, Typography } from 'antd';
import { budgetAllocation, clients, campaigns } from '../../mockData';
import './Allocation.css';

function BudgetAllocation() {
  const { Title } = Typography;

  const columns = [
    { title: 'Client', key: 'client', render: (_, r) => clients.find((c) => c.id === r.clientId)?.name || '—' },
    { title: 'Campaign', key: 'campaign', render: (_, r) => campaigns.find((c) => c.id === r.campaignId)?.name || '—' },
    { title: 'Monthly Budget', dataIndex: 'monthly', key: 'monthly', align: 'right', render: (v) => `$${v.toLocaleString()}` },
  ];

  const total = budgetAllocation.reduce((sum, x) => sum + (x.monthly || 0), 0);

  return (
    <div className="agency-budgets-allocation">
      <Title level={3}>Budget Allocation</Title>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={budgetAllocation}
        pagination={{ pageSize: 5 }}
        summary={() => (
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={2}><strong>Total</strong></Table.Summary.Cell>
            <Table.Summary.Cell index={2} align="right"><strong>${total.toLocaleString()}</strong></Table.Summary.Cell>
          </Table.Summary.Row>
        )}
      />
    </div>
  );
}

export default BudgetAllocation;
